import React, {useState} from "react";
import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik} from "formik";
import styled from "styled-components";
import {GreenButton} from "../buttons/ButtonStyles";
import {useDispatch, useSelector} from "react-redux";
import {changePassword} from "../auth/actions/authAction";
import {displayAlert} from "../../utils/utils";

const PasswordSection = () => {

    const {id} = useSelector(state => state.currentUser)
    const dispatch = useDispatch()
    const [isSend, setIsSend] = useState(false)
    const [isErrors, setIsErrors] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const passwordRegexPhrase = "Votre mot de passe doit contenir 12 caractères, une lettre majuscule, un nombre et un caractère spécial"

    const SignupSchema = Yup.object().shape({
        plainPassword: Yup.string()
            .min(12, "Mot de passe trop court")
            .max(50, "Mot de passe trop long")
            .required('Veuillez écrire votre nouveau mot de passe')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@().{}/\\'€#"$%^&*+[,:;<=>?_|~`-])(?=.{12,})/,
                passwordRegexPhrase),
        confirmPassword: Yup.string()
            .required('Veuillez confirmer votre nouveau mot de passe ')
            .oneOf([Yup.ref('plainPassword'), null], 'Le mot de passe de confirmation ne correspond pas'),
    });

    return (
        <Formik
            initialValues={{
                plainPassword: '',
                confirmPassword: '',
            }}
            validationSchema={SignupSchema}
            onSubmit={async (values, {resetForm}) => {
                try {
                    let dataArray = {}
                    for (const key in values) {
                        if (values.hasOwnProperty(key)) {
                            if (key === "plainPassword") {
                                dataArray.newPassword = values[key]
                            }
                        }
                    }
                    await dispatch(changePassword(id, dataArray))
                    resetForm({values: ""})
                    setIsSend(true)
                    setTimeout(() => setIsSend(false), 2000)
                } catch {
                    setIsErrors(true)
                }
                setIsSubmitted(true)
                setTimeout(() => setIsSubmitted(false), 2000)

            }}
        >

            {() => (
                <Container>
                    <p className={"fw-700"}> Votre nouveau mot de passe doit contenir au moins 12 caractères, une lettre
                        majuscule, un nombre et un caractère spécial</p>
                    {isSubmitted && isSend && displayAlert(false, true)}
                    {isSubmitted && (!isSend || isErrors) && displayAlert(true)}
                    <div className={"flex-col gap-1 w-100"}>
                        <Field
                            name="plainPassword"
                            type="password"
                            className="form-control"
                            placeholder={'Nouveau mot de passe'}
                        />
                        <ErrorMessage
                            name="plainPassword"
                            render={msg => <div><p className="error-text"> {msg} </p></div>}

                        />
                        <Field
                            name="confirmPassword"
                            type="password"
                            className="form-control"
                            placeholder={'Confirmation mot de passe'}

                        />
                        <ErrorMessage
                            name="confirmPassword"
                            render={msg => <div><p className="error-text"> {msg} </p></div>}

                        />

                    </div>
                    <Button type="submit">
                        <h6> Modifier </h6>
                    </Button>
                </Container>
            )}
        </Formik>
    )
}

const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 95%;

  input, select {
    border-radius: 10px;
    padding: 0.5rem;
    border: 1px solid rgba(166, 172, 181, 0.3);
    background-color: #eee;
    outline: none;

    &:focus {
      border-color: rgba(51, 148, 246, 1);
    }
  }
`

const Button = styled(GreenButton)`
  width: 5rem;
  align-self: center;
`


export default PasswordSection